module.exports = __webpack_public_path__ + "static/top_imgM@2x-b90ff721d308afcf8e7e90c5cd609571.png";